import React, { useState } from 'react';
import { IoMdClose } from "react-icons/io";
import SummaryApi from '../common';
import { toast } from 'react-toastify';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'; // Import the new spinner icon

const ChangeRequestStatus = ({ requestId, currentStatus, onClose, callFunc,type }) => {
    const [newStatus, setNewStatus] = useState(currentStatus);
    const [buttonLoading, setButtonLoading] = useState(false); 

    const handleOnChangeSelect = (e) => {
        setNewStatus(e.target.value);
        
    };

    const updateRequestStatus = async () => {
        setButtonLoading(true);
        try {
            const response = await fetch(`${SummaryApi.adminUpdateRequestStatus.url}/${requestId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({ newStatus ,type }),
            });

            const responseData = await response.json();
            if (responseData.success) {
                toast.success(responseData.message);
                onClose();
               callFunc();
              //  window.location.reload() 
            } else {
                toast.error(responseData.message);
            }
        } catch (error) {
            toast.error('فشل في تحديث حالة الطلب');
        }
        finally {
            setButtonLoading(false); // Stop button loading after the process
        }
    };

    return (
        <div className='fixed top-0 bottom-0 left-0 right-0 w-full h-full z-10 flex justify-center items-center bg-slate-200 bg-opacity-50'>
            <div className='mx-auto bg-white shadow-md p-4 w-full max-w-sm'>
                <button className='block ml-auto' onClick={onClose}>
                    <IoMdClose />
                </button>

                <h1 className='pb-4 text-lg font-medium text-right'>تغيير حالة المديونية</h1>

                <div className='flex items-center justify-between my-4'>
                    
                    <select 
                        className='border px-4 py-1 text-right ml-14'
                        value={newStatus}
                        onChange={handleOnChangeSelect}
                    >
                        
                        
                        <option value='accepted'>المبلغ مع مندوب المبيعات </option>
                        <option value='done'>تاكيد استلام المبلغ من مندوب المبيعات     </option>
                    </select>
                </div>
                <label htmlFor='status' className='block mb-4 text-right text-red-500 bg-red-100 border-l-4 border-red-500 p-3 rounded-lg shadow-sm'>
    <span className='font-semibold'>ملاحظة:</span> يرجى العلم انه في حالة تأكيد الاستلام لا يمكن الرجوع عن هذه الخطوة، لذا تأكد جيدًا من استلام المبلغ من مندوب المبيعات.
</label>
                <button
            className={`mt-4 py-2 px-4 bg-blue-800 hover:bg-blue-600 text-white rounded ${buttonLoading  ? 'opacity-50 cursor-not-allowed' : ''}`}
            onClick={updateRequestStatus}
            disabled={buttonLoading } 
        >
            {buttonLoading ? <AiOutlineLoading3Quarters className="animate-spin" /> : 'تحديث حالة المديونية'}
        </button>

            </div>
        </div>
    );
};

export default ChangeRequestStatus;
